<template>
  <div>
    <v-container class="mt-1" v-if="contractData != null">
      <v-layout row v-if="error">
        <v-flex xs12>
          <app-alert @dismissed="onDismissed" :text="error.message"></app-alert>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs12 pb-3 class="display-1 text-xs-center">
          {{contractData.orgName}} Contract Sheet
        </v-flex>
      </v-layout>
      <v-card class="mx-auto" style>
        <v-toolbar flat color="secondary accent-1" dark height="40">
            <v-spacer></v-spacer>
            <v-toolbar-title>CONTRACT BASICS</v-toolbar-title>
            <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text dense>
          <v-layout row>
            <v-flex xs7>
              <v-layout row>
                <v-flex xs4 body-2 pt-1>Contract Name</v-flex>
                <v-flex xs8 text-xs-left pt-1>{{contractData.category}}</v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs4 body-2 pt-1>Contract Number</v-flex>
                <v-flex xs8 text-xs-left pt-1>{{contractData.contractNo}}</v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs4 body-2 pt-1>Contract Duration</v-flex>
                <v-flex xs8 text-xs-left pt-1>{{contractData.fromDate}} - {{contractData.toDate}}</v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs4 body-2 pt-1>Tiers</v-flex>
                <v-flex xs8 text-xs-left pt-1>
                  <div v-for="pt in contractData.priceTiers" :key="pt.id">
                    <div><strong>{{pt.name}}</strong></div>
                    <div>{{pt.description}}</div>
                    <div>{{pt.notes}}</div>
                  </div>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs4 body-2 pt-1>Purchase Through</v-flex>
                <v-flex xs8 text-xs-left pt-1>{{contractData.purchaseThrough}}</v-flex>
              </v-layout>  
              <!-- <v-layout row>
                <v-flex xs4 body-2 pt-1>Highlight of the Offer</v-flex>
                <v-flex xs8 text-xs-left pt-1>{{contractData.contractNo}}</v-flex>
              </v-layout>               -->
            </v-flex>
            <v-flex xs5 >
              <div v-for="offer in contractData.offers" :key="offer.id">
                <div class="body-2">{{offer.name}}</div>
                <div style="white-space: pre-line;">{{offer.detail}}</div>                
              </div>
                
            </v-flex>

          </v-layout>

        </v-card-text>


      </v-card>
      <v-card>
        <v-toolbar flat color="secondary accent-1" dark height="40">
            <v-spacer></v-spacer>
            <v-toolbar-title>REBATE INCENTIVES</v-toolbar-title>
            <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          
        </v-card-text>                
      </v-card>
      <v-layout>
        <v-flex xs3>
        </v-flex>
      </v-layout>

    </v-container>

    {{contractData}}
  </div>
</template>
<script>
// import ctlQuoteItemsInternalTableView from "@/components/ctlQuoteItemsInternalTableView";

// import jobTypeApi from '@/api/jobTypeApi'
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    // ctlQuoteItemsInternalTableView: ctlQuoteItemsInternalTableView,
  },
  data: () => ({
    contractData: {
      basicInfo:{
        facilityShipMethod: {}
      },
      items: []
    },
  }),
  computed: {
    id() {
      return this.$route.params.id;
    },
    error() {
      return this.$store.getters.error;
    }
  },
  watch: {},
  methods: {
      ...mapActions('capsApi', [
          'getGpoContractDetailDataForApiCall',
      ]),
      // ...mapActions('customerSearch', [
      //     'getFacilityDataById'
      // ]),
      async loadContractData() {
        this.contractData = await this.getGpoContractDetailDataForApiCall(this.id)

      },
    onDismissed() {
    }
  },
  created: async function() {
    if(this.id) {
      await this.loadContractData()
    }
  },
  mounted: function() {},
  destroyed: function() {
  }
};
</script>